export default {"src":"/_next/static/media/cart-icon.fbaa104e.svg","height":22,"width":24};